import { render, staticRenderFns } from "./ErrorNote.vue?vue&type=template&id=52e09f93&scoped=true"
import script from "./ErrorNote.vue?vue&type=script&lang=js"
export * from "./ErrorNote.vue?vue&type=script&lang=js"
import style0 from "./ErrorNote.vue?vue&type=style&index=0&id=52e09f93&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e09f93",
  null
  
)

export default component.exports